// extracted by mini-css-extract-plugin
module.exports = {"align_center":"Identification_align_center__1x02V","practicalAnswer":"Identification_practicalAnswer__1CWde","col":"Identification_col__n4hdt"};